import { childsAjustes } from "./childrens/ajustesEmpresa";
import { childsHerramientas } from "./childrens/herramientas";
import { childsPlataformas } from "./childrens/plataformas";
import { childsPanel } from "./childrens/panel";
export default {
  name: "admin",
  component: () =>
    import(
      /* webpackChunkName: "adminLayout" */ "@/modules/admin/layouts/MainAdminLayout.vue"
    ),
  redirect: "/admin/ajustesEmpresa",
  children: [
    {
      path: "ajustesEmpresa",
      name: "admin-ajustesEmpresa",
      component: () =>
        import(
          /* webpackChunkName: "ajustesEmpresaLayout" */ "@/modules/admin/layouts/childrenLayouts/AjustesEmpresaLayout.vue"
        ),
      redirect: "/admin/ajustesEmpresa/usuarios",
      children: childsAjustes,
    },
    {
      path: "herramientas",
      name: "admin-herramientas",
      component: () =>
        import(
          /* webpackChunkName: "herramientasLayout" */ "@/modules/admin/layouts/childrenLayouts/HerramientasLayout.vue"
        ),

      children: childsHerramientas,
    },
    {
      path: "plataformas",
      name: "admin-plataformas",
      component: () =>
        import(
          /* webpackChunkName: "plataformasLayout" */ "@/modules/admin/layouts/childrenLayouts/PlataformasLayout.vue"
        ),

      children: childsPlataformas,
    },
    {
      path: "panel",
      name: "admin-panel",
      component: () =>
        import(
          /* webpackChunkName: "panelLayout" */ "@/modules/admin/layouts/childrenLayouts/PanelControlLayout.vue"
        ),

      children: childsPanel,
    },
  ],
};
